﻿const touchEvent = 'ontouchstart' in window ? 'touchstart' : 'click';

const tabArticles = document.querySelectorAll('.tabs-page__article')
const tabNavItems = document.querySelectorAll('.tabs-page__nav-item')
const focusElement = document.querySelector('#focus-element')

const hideArticles = () => {
    Array.from(tabArticles).forEach(article => {
        article.classList.remove('active')
        article.setAttribute('aria-hidden', 'true')

        if (article.classList.contains('movie-page__content__section')) {
            Array.from(article.querySelectorAll('.card__movie-page')).forEach(movie => { movie.removeAttribute('data-fancybox') })
        }
    })
    Array.from(tabNavItems).forEach(button => { button.classList.remove('active') })
}

const resetFocus = () => {
    let el = document.activeElement as HTMLElement | null
    if (el) el.blur()
}

const showTab = (id: string, isOnLoad?: boolean) => {
    const button = document.querySelector('[data-tab-for="' + id + '"')
    const article = document.querySelector('[data-tab-index="' + id + '"]')

    if (button && article) {
        hideArticles()

        article.classList.add('active')
        article.setAttribute('aria-hidden', 'false')
        button.classList.add('active')

        if (article.classList.contains('movie-page__content__section')) {
            Array.from(article.querySelectorAll('.card__movie-page')).forEach(movie => { movie.setAttribute('data-fancybox', 'filmgalleri') })
        }

        if (article.classList.contains('calendar-page__content__section')) {
            // Replace label
            let toggleLabel = document.querySelector('.filter--dropdown__toggle--label')
            let newText = button.getAttribute('title')
            toggleLabel.innerHTML = newText
            // Close dropdown
            document.querySelector('.filter--dropdown__container').classList.remove('open')
        }

        if (article.classList.contains('information-page__article') && !isOnLoad) {
            let focusEl = document.querySelector('#focus')
            if (focusEl) focusEl.scrollIntoView({ behavior: 'smooth' })

        }

        window.history.replaceState({}, '', '?' + id)

        resetFocus()
    }
}

const loadTabs = () => {
    let locationSearch = window.location.search
    if (window.location.hash.length > 0) locationSearch = window.location.hash.replace('#', '?')
    let firstArticle = document.querySelector('[data-tab-number="0"]')

    if (document.querySelector('#PageCalendar')) {
        let current = document.querySelector('#calendar-page__settings').getAttribute('data-now')
        firstArticle = document.querySelector('[data-tab-index="' + current + '"]')
    }

    if (locationSearch.length > 1 && firstArticle) {
        let tabID = locationSearch
        if (tabID.indexOf('?') >= 0) {
            tabID = tabID.split('?')[1]
            let match = document.querySelector('[data-tab-index="' + tabID + '"]') != null ? tabID : firstArticle.getAttribute('data-tab-index')
            showTab(match, true)
        } else {
            showTab(firstArticle.getAttribute('data-tab-index'), true)
        }
    } else if (firstArticle) {
        showTab(firstArticle.getAttribute('data-tab-index'), true)
    }
}

export function initTabsPage() {
    if (!document.querySelector('#PageQuiz') && !document.querySelector('#SearchPage') && tabArticles && tabNavItems) {

        Array.from(tabNavItems).forEach(item => {
            const button = item as HTMLElement | null

            if (button != null) {
                button.addEventListener('click', (e: MouseEvent) => {
                    let tabID = button.getAttribute('data-tab-for')
                    showTab(tabID)
                })
            }
        })

        loadTabs()
    }
}